import api from "../core/axios";

export const businessPermitsAPI = {
    getAll: (params) => api.get("/business-permits/businesses", { params }),
    getById: (id) => api.get(`/business-permits/businesses/${id}`),
    create: (data) => api.post("/business-permits/businesses", data),
    update: (id, data) => api.put(`/business-permits/businesses/${id}`, data),
    delete: (id) => api.delete(`/business-permits/businesses/${id}`),
    getStatistics: () => api.get("/business-permits/dashboard"),
    export: (params = {}) => api.get("/business-permits/businesses", {
        params: { ...params, export: true },
        responseType: 'blob'
    }),

    getAllPermits: (params) => api.get("/business-permits/permit-applications", { params }),
    getDocumentRequirements: () => api.get("business-permits/permit-applications/select-requirements"),
    getBusinesses: () => api.get("/business-permits/permit-applications/select-businesses"),
    getPermitById: (id) => api.get(`/business-permits/permit-applications/${id}`),
    createPermit: (data) => api.post("/business-permits/permit-applications", data),
    updatePermit: (id, data) => api.post(`/business-permits/permit-applications/${id}`, data),
    updatePermitStatus: (id, data) => api.patch(`/business-permits/permit-applications/${id}/update-status`, data),
    deletePermit: (id) => api.delete(`/business-permits/permit-applications/${id}`),
    exportPermits: (params = {}) => api.get("/business-permits/permit-applications", {
        params: { ...params, export: true },
        responseType: 'blob'
    }),

    getAllExpiringPermits: (params) => api.get("/business-permits/tab-view", { params }),
    getExpiringBusinessPermitById: (id) => api.get(`/business-permits/${id}/expiring-permits`),
    getExpiredBusinessPermitById: (id) => api.get(`/business-permits/${id}/expired-permits`),
    exportExpiringPermits: (params = {}) => api.get("/business-permits/tab-view", {
        params: { ...params, export: true },
        responseType: 'blob'
    }),

    //CMS Business Permit Requirements
    getAllRequirements: (params) => api.get("/business-permits/permit-requirements", { params }),
    getRequirementById: (id) => api.get(`/business-permits/permit-requirements/${id}`),
    createRequirement: (data) => api.post("/business-permits/permit-requirements", data),
    updateRequirement: (id, data) => api.put(`/business-permits/permit-requirements/${id}`, data),
    updateStatusRequirement: (id, data) => api.patch(`/business-permits/permit-requirements/${id}/update-status`, data),
    archiveRequirement: (id) => api.delete(`/business-permits/permit-requirements/${id}`),
    restoreRequirement: (id) => api.patch(`/business-permits/permit-requirements/${id}/restore-archived`),

    //CMS Business Type 
    getAllBusinessTypes: (params) => api.get("/business-permits/business-types", { params }),
    getBusinessTypeById: (id) => api.get(`/business-permits/business-types/${id}`),
    createBusinessType: (data) => api.post("/business-permits/business-types", data),
    updateBusinessType: (id, data) => api.put(`/business-permits/business-types/${id}`, data),
    archiveBusinessType: (id) => api.delete(`/business-permits/business-types/${id}`),
    restoreBusinessType: (id) => api.patch(`/business-permits/business-types/${id}/restore-archived`),

    //CMS Nature of Business
    getAllNatureOfBusiness: (params) => api.get("/business-permits/business-natures", { params }),
    getNatureOfBusinessById: (id) => api.get(`/business-permits/business-natures/${id}`),
    createNatureOfBusiness: (data) => api.post("/business-permits/business-natures", data),
    updateNatureOfBusiness: (id, data) => api.put(`/business-permits/business-natures/${id}`, data),
    archiveNatureOfBusiness: (id) => api.delete(`/business-permits/business-natures/${id}`),
    restoreNatureOfBusiness: (id) => api.patch(`/business-permits/business-natures/${id}/restore-archived`),

    getOwners: (params) => api.get("/business-permits/businesses/search-resident", { params }),

    getBusinessPermitExpiringById: (id) => api.get(`/business-permits/${id}/expiring-permits`),
    getBusinessPermitExpiredById: (id) => api.get(`/business-permits/${id}/expired-permits`),

    endorse: (id, data) => api.post(`/business-permits/${id}/endorse`, data),
    renew: (id, data) => api.post(`/business-permits/${id}/renew-permits`, data),
};

